import { morphism } from 'morphism'

import flightLegsSchema from './flightLeg'

import FlightLegsModel from '../models/FlightLeg'

import constants from '../config/constants'

import {
  dateToFrontEndFormat,
  dateToHoursFormat,
  dateToDayFormat,
} from '../utils/dates'

/**
 * Format flightInformation object
 *
 * @param {Object} flightInformation
 * @returns {Array}
 */
const flightLegs = ({ flightLegs = [] }) => {
  return flightLegs.map(flightLeg => {
    return morphism(flightLegsSchema, flightLeg, FlightLegsModel)
  })
}

/**
 * Create the departureDate from the full departureDate
 * @param {Object} flight
 * @returns {String}
 */
const departureDate = ({ std }) =>
  dateToFrontEndFormat(std, constants.stdDateFormat)

/**
 * Create the departureTime from the full departureDate
 * @param {Object} flight
 * @returns {String}
 */
const departureTime = ({ std }) =>
  dateToHoursFormat(std, constants.stdDateFormat)

/**
 * Create the departureDay from the full departureDate
 * @param {Object} flight
 * @returns {String}
 */
const departureDay = ({ std }) => dateToDayFormat(std, constants.stdDateFormat)

/**
 * Create the arrivalDate from the full arrivalDate
 * @param {Object} flight
 * @returns {String}
 */
const arrivalDate = ({ sta }) =>
  dateToFrontEndFormat(sta, constants.stdDateFormat)

/**
 * Create the arrivalTime from the full arrivalDate
 * @param {Object} flight
 * @returns {String}
 */
const arrivalTime = ({ sta }) => dateToHoursFormat(sta, constants.stdDateFormat)

/**
 * Create the arrivalDay from the full arrivalDate
 * @param {Object} flight
 * @returns {String}
 */
const arrivalDay = ({ sta }) => dateToDayFormat(sta, constants.stdDateFormat)

export default {
  sta: 'sta',
  arrival: 'sta',
  staUtc: 'staUtc',
  arrivalUtc: 'staUtc',
  arrivalDate,
  arrivalDay,
  arrivalTime,

  std: 'std',
  departure: 'std',
  stdUtc: 'stdUtc',
  departureUtc: 'stdUtc',
  departureDate,
  departureDay,
  departureTime,

  flightId: 'flight.id',
  flightNumber: 'flightNumber',
  flightLegs,

  destination: 'destination',
  origin: 'origin',
}
